export const initialUserState = {
  name: '',
  email: '',
  description: '',
  providers: [],
  id: '',
  properties: {},
  pins: {},
  metadata: {
    profilePicUrl: '',
    createdAt: '',
  },
  baseTags: {},
  wallet: {
    coins: 0,
    currency: 0,
  },
  active: false,
};

export const initialHoveredUser = {
  channel: {
    locations: [],
    topics: [],
    name: '',
    orgId: '',
    streamId: '',
    id: '',
    visible: true,
    description: '',
    boosts: {},
    restricted: false,
    metadata: {
      itemsHash: '',
      subscriberCount: 1,
      coverPicUrl: '',
      profilePicUrl: '',
      followerCount: 0,
      platformBoost: 0,
      createdAt: '',
      createdBy: '',
    },
  },
  channelUserdata: {
    userSubscriptions: [],
    hasFollowed: false,
    hasBookmarked: false,
    channelCID: {
      orgId: '',
      streamId: '',
      channelId: '',
    },
    userRoleMapping: {
      userId: '',
      roles: [],
      mapping: [],
    },
  },
  streamUserdata: {
    hasBookmarked: false,
    streamCID: {
      orgId: '',
      streamId: '',
    },
    userChannels: [],
    userRoleMapping: {
      userId: '',
      roles: [],
      mapping: [],
    },
  },
  subscriptions: [],
  users: [],
};
